module.exports = __webpack_public_path__ + "img/app.a932df56.png";